import request from '@/utils/request'

// 执行诊断
export function diagnoseSimCard(params) {
  return request({
    url: `/customer/sim_card_diagnose`,
    method: 'get',
    params: params
  })
}

// 更新 sim_card 运营商数据
export function updateSimCardDiagnoseData(id) {
  return request({
    url: `/sim_cards/${id}/diagnose_data`,
    method: 'post'
  })
}
